import React, { useRef, useLayoutEffect, useState, useEffect } from 'react';
import { FixedSizeList as TBody } from 'react-window';
import cssClasses from './body.css';
import Empty from './Empty/empty';
import isEqual from 'lodash.isequal';
import Row from './Row/row-nolazy';

const RowItem = ({ data, index, style, isScrolling }) => {
    const rowUpdated = !isEqual(data.rows[index], data.memoizedRows[index]);
    const loadingRow = <div className={cssClasses.placeHolderRow} style={style}>{data.loadingColumns}</div>
    if (rowUpdated) data.resetRows(data.rows);
    return <Row
        index={index}
        style={style}
        rows={data.rows}
        columns={data.columns}
        height={data.height}
        rowheight={data.rowheight}
        columnWidthList={data.columnWidthList}
        focusedCell={data.focusedCell}
        setCellDirectly={data.setCellDirectly}
        resizingColumn={data.resizingColumn}
        loadingRow={loadingRow}
        disabledCellChecker={data.disabledCellChecker}
        getRowKey={data.getRowKey}
        contextMenuId={data.contextMenuId}
        rowUpdated={rowUpdated} />
};

const Body = (props) => {
    // console.log(`Body rendering`);
    const listRef = useRef(undefined);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        setRows(props.rows);
    }, []);
    const resetRows = (newRows) => {
        setRows(newRows);
    }
    const rowData = { ...props };
    
    rowData.memoizedRows = rows;
    rowData.resetRows = resetRows;

    useLayoutEffect(() => {
        if (props.focusedCell.coords.x) {
            listRef.current &&
                listRef.current.scrollToItem(props.focusedCell.coords.x);
        }
    }, [props.focusedCell])

    if (rowData.rows && rowData.rows.length > 0)
        return <TBody
            ref={listRef}
            height={props.height}
            itemCount={props.rows.length}
            itemSize={props.rowheight}
            className={cssClasses.table}
            overscanCount={3}
            // useIsScrolling
            itemData={rowData} >
            {RowItem}
        </TBody>
    else return <Empty />
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/DataTable/Body/body-nolazy.js